export default __webpack_public_path__ + "static/SR USA - Application Guia - Color Caramelo en Polvo (en inglés)-d99669ba7947d1191bcd33f99480846b.pdf";